import { useRoutes } from 'react-router-dom'

import LoginRoutes from './LoginRoutes'
import MainRoutes from './MainRoutes'
import MaintenanceRoutes from './MaintenanceRoutes'

export default function ThemeRoutes() {
  return useRoutes([MainRoutes, LoginRoutes, MaintenanceRoutes])
}
